<template>
  <div id="win-size-change-box">
    <Modal v-model="modal6" :title="$t('warn0')">
      <div style="text-align:left;font-size: 14px;padding: 0 50px;">
        <p style="font-size: 17px;text-align: center;margin-bottom: 6px;">{{$t('warn1')}}</p>
        <p style="text-align: center;margin-bottom: 6px;">{{$t('warn2')}}</p>
        <p>{{$t('warn3')}}
          <span style="color: orange;">{{$t('warn4')}}</span>。</p>
        <p>{{$t('warn5')}}
          <span style="color: orange;">{{$t('warn6')}}</span>
        </p>
      </div>
      <div slot="footer">
        <Row>
          <Col span="11" ><Button size="large" long @click.native="noPrompt" >{{$t('warn7')}}</Button></Col>
          <Col span="11" offset="1"><Button type="warning" size="large" long @click.native="modal6 = false" >{{$t('warn8')}}</Button></Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      modal6: false,
      isPrompt: true
    }
  },
  created () {
  },
  mounted () {
    // 如果有用户信息，直接跳到首页
    this.windowSizeChange()
    window.addEventListener('resize', () => {
      this.isPrompt && this.windowSizeChange()
    })
  },
  methods: {
    windowSizeChange () {
      let ratio = 0;
      let screen = window.screen;
      let ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }

      if (ratio) {
        ratio = Math.round(ratio * 100);
      }

      let noWarningSize = this.$cookies.get('noWarningSize');

      if (ratio !== 100 && !noWarningSize) {
        this.modal6 = true;
      } else {
        this.modal6 = false;
      }
    },
    noPrompt () {
      this.modal6 = false
      this.isPrompt = false
      this.$cookies.set('noWarningSize', true, 60 * 60 * 24);
    }
  }
}
</script>

<style lang="less" scoped>
.win-size-change-box {
}
</style>
